import React, { useState, useEffect } from "react";
import "./style.css";

const VIPAdsPopup = ({ onClose,cards }) => {

  const [error, setError] = useState(null); // Added error state
  const [ads, setAds] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setAds(cards.filter((e)=>e.AddPlacementZone === "Vip").sort((a, b) => a.DisplayOrder - b.DisplayOrder)); 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [cards]);

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button aria-label="Close dialog" className="close-button" onClick={onClose} ariel-hidden="true">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 style={{ fontSize: "12px" }} className="popup-title">VIP ADS</h2>
        <div className="popup-container1">
          <div className="ads-grid">
            {error ? (
              <p>{error}</p> // Display error message if there's an error
            ) : ads.length === 0 ? (
              <p>Loading ads...</p> // Display a loading message while ads are being fetched
            ) : (
              ads.map((ad, index) => (
                <div key={index} className="ad-card">
                
                  <img
                    src={
                      ad.ImageBlobUrl ||
                      `https://picsum.photos/400/400?random=${index}`
                    }
                    alt={`Ad image for ${ad.LabelText || "bonus offer"}`} // More descriptive alt text
                    className="ad-image"
                  />
                  <div className="ad-content">
                    <div className="add-title-price">
                      <h1 style={{ fontSize: "14px" }} className="ad-title">
                        {ad?.LabelText
                          ? `${ad.LabelText
                              .toUpperCase()}`
                          : "JOIN NOW"}
                      </h1>
                      <p className="ad-price">{`${ad?.BonusAmountText}`}</p>
                    </div>
                    <a href={ad.RedirectUrl} target="_blank" rel="nofollow">
                      <button className="bonus-button">
                        {ad.buttonText || "GO TO SITE"}
                      </button>
                    </a>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VIPAdsPopup;
